import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";
import Breadcrumb from "@/components/feature/Breadcrumb";
import Pagination from "@/components/feature/Pagination";
import { usePageMeta } from "@/hooks/usePageMeta";

const PAGE_SIZE = 4;

export default function NewsPage() {
  const [page, setPage] = useState(1);

  usePageMeta(
    "影视资讯 - 蜜月TV",
    "蜜月TV影视资讯频道，汇聚行业动态、剧集新闻与观影指南，第一时间了解影视圈最新消息。",
  );

  const totalPages = Math.max(1, Math.ceil(newsList.length / PAGE_SIZE));
  const paged = useMemo(
    () => newsList.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE),
    [page],
  );

  return (
    <div className="w-full px-4 md:px-8 py-6 md:py-8">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "影视资讯" }]} />

      <header className="mt-4 mb-8">
        <h1 className="text-2xl md:text-3xl font-black text-foreground-950">影视资讯</h1>
        <p className="text-sm text-foreground-500 mt-2">
          行业动态 · 剧集新闻 · 观影指南，掌握影视圈的最新风向。
        </p>
      </header>

      {paged.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-20 text-center rounded-lg bg-background-50 border border-dashed border-background-300">
          <i className="ri-newspaper-line text-5xl text-foreground-300" />
          <h2 className="text-base font-bold text-foreground-800 mt-4">暂时无资讯更新</h2>
          <p className="text-sm text-foreground-500 mt-2">请稍后再来查看最新内容。</p>
        </div>
      ) : (
        <>
          <div className="space-y-4">
            {paged.map((item) => (
              <Link
                key={item.id}
                to={`/detail/${item.id}`}
                className="group flex flex-col sm:flex-row gap-4 sm:gap-6 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <div className="w-full sm:w-60 shrink-0 aspect-[16/9] rounded-md overflow-hidden bg-background-200">
                  <img
                    src={item.cover}
                    alt={`${item.title} 资讯配图`}
                    title={`${item.title} - 蜜月TV影视资讯`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="min-w-0 flex flex-col">
                  <span className="text-xs font-medium text-accent-700 mb-1.5">{item.category}</span>
                  <h2 className="text-base md:text-lg font-bold text-foreground-900 leading-snug group-hover:text-primary-700 transition-colors">
                    {item.title}
                  </h2>
                  <p className="text-sm text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
                    {item.summary}
                  </p>
                  <span className="text-xs text-foreground-400 mt-auto pt-3 flex items-center gap-1.5">
                    <i className="ri-time-line" /> {item.date}
                  </span>
                </div>
              </Link>
            ))}
          </div>
          <Pagination current={page} totalPages={totalPages} onChange={setPage} />
        </>
      )}
    </div>
  );
}